import { makeStyles, tokens } from "@fluentui/react-components";
import { ReactNode } from "react";

const useStyles = makeStyles({
    root: {
        fontSize: tokens.fontSizeHero700,
        marginBottom: "1rem",
        display: "flex",
        alignItems: "center",
        gap: "0.5rem"
    }
});

export default function SubPageTitle(
    {
        icon,
        title,
        subTitle
    }: {
        icon: ReactNode,
        title: string,
        subTitle: string
    }
) {
    const styles = useStyles();

    return (
        <div className={styles.root}>
            {icon}
            <span style={{ fontWeight: tokens.fontWeightSemibold }}>{title} | </span> {subTitle}
        </div>
    )
};